export const he = {
  'Log Out': 'התנתק',
  'Properties': 'מאפיינים',
  'Fields': 'שדות',
  'Save Form': 'שמור טופס',
  'Duplicate Form': 'שכפל טופס',
  "Chain": "רשת",
  'Select Chain': 'בחר רשת'
};
